import React, {Component} from 'react';
import PropTypes from "prop-types";
import Api from "../../utils/Api";
import moment from 'moment';
import LoadingSplash from "../../globalComponents/LoadingSplash";
import TableContainer from "../../utils/TableContainer";
import StaticFunctions from "../../utils/StaticFunctions";
import Timeformat from "../../utils/Timeformat";
import TimeRange from "../../utils/TimeRange";
import TimerangeSelector from "../../globalComponents/TimerangeSelector";
import Select from "react-select";

class LogFilesContainer extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
    };

    constructor(props) {

        super(props);

        this.api = new Api();

        this.state = {
            reportStatus: null,
            reportParams: null,
            timeRange: null, // TimeRange
            selectedFiles: null,
            selectedLimit: 10,
            requestedParams: null, // stringified parameters to prevent double-request
            logFiles: null
        };

        this.translate = this.props.baseData.translate;
        this.userLanguage = this.props.baseData.userData.language;
        this.timeFormats = this.props.baseData.languages.getFormatByLanguage(this.userLanguage);
        this.saveSettings = this.props.baseData.saveSettings;
        this.selecteableFiles = [
            {value: 'aliveJobs', label: 'aliveJobs'},
            {value: 'countStatusNotFinal', label: 'countStatusNotFinal'},
            {value: 'countBdeNotFinal', label: 'countBdeNotFinal'},
            {value: 'machines', label: 'machines'},
            {value: 'statusNotFinal', label: 'statusNotFinal'},
            {value: 'bdeNotFinal', label: 'bdeNotFinal'}
        ];
        this.selecteableLimits = [
            {value: 1, label: 1},
            {value: 5, label: 5},
            {value: 10, label: 10},
            {value: 50, label: 50},
            {value: 100, label: 100},
            {value: 500, label: 500},
            {value: 1000, label: 1000}
        ];

        this.requestLogs = this.requestLogs.bind(this);
        this.timerangeChanged = this.timerangeChanged.bind(this);
        this.fileSelected = this.fileSelected.bind(this);
        this.limitSelected = this.limitSelected.bind(this);

    }

    /*componentWillMount() {

        this.requestLogs();

    }*/

    componentWillMount() {

        const settings = this.props.baseData.userData.settings ? this.props.baseData.userData.settings : {};
        const newState = {};

        // Timerange aus den userprops laden
        const tr = new TimeRange();
        const momentYesterday = moment().add(-1, 'days');

        tr.setRange(momentYesterday.clone().startOf('day'), momentYesterday.clone().endOf('day'));

        if (tr && tr.isValid()) newState.timeRange = tr;

        // Files aus den userprops laden
        const files = (settings.selectedLogFiles) ? settings.selectedLogFiles : null;

        if (files) {
            try {
                const parsedFiles = JSON.parse(files);

                if (parsedFiles && parsedFiles.length > 0) newState.selectedFiles = parsedFiles;
            } catch (e) {
                console.error("Error parsing selectedLogFiles from settings", e);
            }
        }

        // Limit aus den userprops laden
        const selectedLimit = (settings.selectedLimit) ? settings.selectedLimit : null;

        if (selectedLimit) newState.selectedLimit = selectedLimit;

        if (newState) this.setState(newState, () => this.requestLogs());

    }

    requestLogs() {

        if (this.state.reportStatus === 'requested') return null;

        const params = this.getRequestParams();

        if (params === null) return null;

        const sParams = JSON.stringify(params);

        if (sParams === this.state.requestedParams) return null;

        const {reportParams, ...newReportParams} = {...this.state};

        const callback = function(res) {
            if (res) {
                this.setState({
                    reportStatus: 'ready',
                    logFiles: res
                });
            }
        }.bind(this);

        this.setState({
            reportStatus: 'requested',
            reportParams: newReportParams,
            requestedParams: sParams
        }, () => {
            this.api.request('AdminFunctions', params, callback);
        });

    }

    getRequestParams() {

        const tr = this.state.timeRange;
        const dateFrom = tr ? tr.getFromMoment() : null;
        const dateTill = tr ? tr.getTillMoment() : null;
        const selectedFiles = this.state.selectedFiles;

        // Check, if all data is set
        if (dateFrom === null || dateTill === null || selectedFiles === null) return null;
        if (!dateFrom.isValid() || !dateTill.isValid()) return null;

        return {
            action: 'getLogFiles',
            currentCompanyId: this.props.baseData.companies.currentCompany.id,
            selectedFiles: this.state.selectedFiles,
            from: dateFrom.unix(),
            till: dateTill.unix(),
            limit: this.state.selectedLimit,
            timezone: this.props.baseData.companies.currentCompany.timezone
        };

    }

    timerangeChanged(newRange) {

        if (newRange && (newRange instanceof TimeRange) && newRange.isValid()) {
            this.setState({
                timeRange: newRange,
            });

            // Safe Timerange to Userconfig
            if (this.saveSettings) {
                let serialized = newRange.serialize();

                this.saveSettings('ReportTimeRange', serialized);
            }
        }

        this.requestLogs();

    }

    fileSelected(files) {

        const selectedFiles = (files && files.length > 0) ? files.map(o => o.value) : null;

        this.setState({
            selectedFiles
        }, () => this.requestLogs());

        // Safe files to Userconfig
        if (this.saveSettings && files) {
            this.saveSettings('selectedLogFiles', JSON.stringify(selectedFiles));
        }

    }

    limitSelected(limit) {

        const selectedLimit = (limit && limit.value) ? limit.value : 10;

        this.setState({
            selectedLimit
        }, () => this.requestLogs());

        // Safe files to Userconfig
        if (this.saveSettings) {
            this.saveSettings('selectedLimit', selectedLimit);
        }

    }

    getTableColumns(row, hiddenKeys) {

        if (!row) return [];

        const keys = Object.keys(row).filter(key => !hiddenKeys.includes(key));

        return keys.map(
            (column) => {
                return {
                    key: column,
                    name: column,
                    sortType: 'string'
                };
            }
        );

    }

    getTableRows(rows) {

        if (!rows) return [];

        const timestampKeys = ['last_seen', 'last_operation', 'last_bde_data'];

        return rows.map((value, index) => {
            let valueCopy = {...value};

            timestampKeys.forEach(
                (key) => {
                    if (valueCopy[key]) {
                        valueCopy[key] = (valueCopy[key] > 0) ? Timeformat.fromUnix(valueCopy[key]).getFormatedDate('YYYY-MM-DD HH:mm:ss') : valueCopy[key];
                    }
                }
            );

            return valueCopy;
        });

    }

    createTable(tableKey, tableRows) {

        if (this.state.reportStatus === 'requested') return <LoadingSplash color={'dark'}/>;
        if (!tableRows) return [];

        const hiddenKeys = [];
        const columns = this.getTableColumns(tableRows[0], hiddenKeys);
        const rows = this.getTableRows(tableRows);
        const found = (tableRows.length > 0) ? StaticFunctions.formatedNumber(tableRows.length) + ' ' + tableKey + ' ' + this.translate('found') + '.' : '';

        if (columns.length === 1 && tableRows.length === 1) return this.createInputInfo(tableKey, tableRows);

        return (
            <div key={tableKey} className="col-sm-12 ma-bo-20 clearfix">
                <nav>
                    <h1>{tableKey}</h1>
                </nav>

                <div>
                    <p>{found}</p>
                </div>

                <div className="clearfix">
                    <TableContainer
                        baseData={this.props.baseData}
                        tableClasses="nowrap"
                        columns={columns}
                        rows={rows}
                        maxHeight={690}
                    />
                </div>
            </div>
        );

    }

    createInputInfo(tableKey, tableRows) {

        if (!tableKey || !tableRows) return null;

        const row = tableRows[0];
        const columnName = Object.keys(row);

        return (
            <div key={tableKey} className="col-sm-12 ma-bo-20 clearfix">
                <nav>
                    <h1>{tableKey}</h1>
                </nav>

                <div className="formRow">
                    <table>
                        <tbody>
                            <tr>
                                <td className="text-left labelSpan">{columnName}</td>

                                <td className="text-left">
                                    <input
                                        name="columnName"
                                        type="text"
                                        value={row[columnName]}
                                        disabled={true}
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );

    }

    renderRequestButton() {

        const reportParams = this.getRequestParams();
        const sParams = JSON.stringify(reportParams);

        if (this.state.reportStatus === 'requested' || sParams === this.state.requestedParams) {
            return (
                <a className="prewLink disabled-link">{this.translate('requestReport')}</a>
            );
        } else {
            return (
                <a className="prewLink orangeButton" onClick={() => this.requestLogs()}>{this.translate('requestReport')}</a>
            );
        }

    }

    render() {

        const timerangeFormat = this.timeFormats.fullDate;
        const requestButton = this.renderRequestButton();

        const logFiles = this.state.logFiles;
        const tables = (this.state.reportStatus === 'requested') ? <LoadingSplash color={'dark'}/> : [];

        if (this.state.reportStatus !== 'requested' && logFiles && logFiles.length > 0) {
            logFiles.forEach(
                (table) => {
                    tables.push(this.createTable(table.key, table.data));
                }
            );
        }

        return (
            <div>
                <div>
                    <nav>
                        <h1>{this.translate('logFiles')}</h1>
                    </nav>
                </div>

                <div id="reportSettings" className="clearfix">
                    <div className="clearfix">
                        <div className="col-sm-4">
                            <div className="ma-bo-10">
                                <h4>{this.translate('timerange')}</h4>

                                <div>
                                    <TimerangeSelector
                                        TimeRange={this.state.timeRange}
                                        displayFormat={timerangeFormat}
                                        translate={this.translate}
                                        onTimeRangeChanged={this.timerangeChanged}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-2">
                            <div className="ma-bo-10">
                                <h4>{this.translate('files')}</h4>

                                <div>
                                    <Select
                                        name="logFileSelector"
                                        className="chosen-container-single"
                                        options={this.selecteableFiles}
                                        onChange={this.fileSelected}
                                        value={this.selecteableFiles.filter(o => this.state.selectedFiles && this.state.selectedFiles.includes(o.value))}
                                        placeholder={this.translate('select') + '...'}
                                        noOptionsMessage={() => this.translate('noResultsFound')}
                                        isMulti={true}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-2">
                            <div className="ma-bo-10">
                                <h4>{this.translate('limit')}</h4>

                                <div>
                                    <Select
                                        name="limitSelector"
                                        className="chosen-container-single"
                                        options={this.selecteableLimits}
                                        onChange={this.limitSelected}
                                        value={this.selecteableLimits.find(o => String(o.value) === String(this.state.selectedLimit)) || null}
                                        placeholder={this.translate('select') + '...'}
                                        noOptionsMessage={() => this.translate('noResultsFound')}
                                        isMulti={false}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="bottomLinks clearfix">
                    {requestButton}
                </div>

                <div className="formSettings clearfix">
                    {tables}
                </div>

                <div className="bottomLinks clearfix">
                    <a className="prewLink" onClick={() => this.props.baseData.pageNavigation('admin')}>{this.translate('backToOverview')}</a>
                </div>
            </div>
        );

    }

}

export default LogFilesContainer;
